module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px",
      "font-weight": "bold"
    }
  }, [_vm._v("Windows FAQ")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("1、Windows端MOA安装包打不开怎么办？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    a、先到安装包下载目录刷新一下。")]), _vm._v(" "), _c('p', [_vm._v("    b、右键安装包-->\"属性\",查看安装包大小是否正确，如果不正确则重新下载。")]), _vm._v(" "), _c('p', [_vm._v("    c、将安装包加入杀毒软件信任白名单。")]), _vm._v(" "), _c('p', [_vm._v("    d、如果还打不开，请联系信息安全部 jijuntao，yuyutang。")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("2、Windows端MOA如何进行手动更新？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _c('p'), _c('p', [_vm._v("    “以管理员身份运行”运行安装包，直接覆盖安装即可。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("3、Windows端MOA安装时被杀毒软件报为病毒")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    此为杀毒软件误报，将安装包加入信任白名单即可。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("4、Windows端MOA安装时提示需要输入管理员用户名和密码")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/windows_FAQ/windows_FAQ_pic01.png"),
      "width": "400px",
      "height": "420px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    此为当前用户没有管理员权限，输入管理员密码即可。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("5、提示“禁止重复运行itsecClient 程序！”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/windows_FAQ/windows_FAQ_pic02.jpg"),
      "width": "330px",
      "height": "220px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("原因：")])]), _vm._v(" "), _c('p', [_vm._v("    遇到这种情况说明MOA客户端程序已经运行。如果仍然不能看到MOA运行界面，则重新运行MOA客户端程序。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    a、先杀掉当前的MOA进程，在任务管理器中结束 itsecClient.exe和itsecClientUpdate.exe。")]), _vm._v(" "), _c('p', [_vm._v("    b、以管理员权限运行itsecClient.exe。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("6、提示“duang！程序遇到问题即将要关闭”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/windows_FAQ/windows_FAQ_pic03.jpg"),
      "width": "400px",
      "height": "200px"
    }
  })]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/windows_FAQ/windows_FAQ_pic04.jpg"),
      "width": "500px",
      "height": "200px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    a、尝试重新运行moa客户端程序。")]), _vm._v(" "), _c('p', [_vm._v("    b、请联系信息安全部 jijuntao，yuyutang。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("7、MOA界面上显示“客户端状态 离线”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/windows_FAQ/windows_FAQ_pic05.png"),
      "width": "600px",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    a、检查网络是否正常，是否能正常访问互联网和公司办公系统。")]), _vm._v(" "), _c('p', [_vm._v("    b、询问是否被其他同事扫码。")]), _vm._v(" "), _c('p', [_vm._v("    c、使用新的安装包重新安装。/p>\n  ")]), _c('p', [_vm._v("    d、请联系信息安全部 jijuntao，yuyutang。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("8、提示“加载资源文件失败”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/windows_FAQ/windows_FAQ_pic06.png"),
      "width": "700px",
      "height": "450px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("原因：")])]), _vm._v(" "), _c('p', [_vm._v("    组件缺失，卸载时删掉了资源文件，但是进程还在运行。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    使用最新的安装包覆盖安装即可。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("9、MOA版本查看")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/windows_FAQ/windows_FAQ_pic07.png"),
      "width": "900px",
      "height": "660px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-303d50a5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/windows_FAQ.vue
// module id = 635
// module chunks = 1